module.exports = __webpack_public_path__ + "assets1783936157458/img/shezhi-select.6ce61d90.svg";